import { topicWall } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const sizeMap: Record<number, string> = {
  1: "px-4 py-2 text-sm",
  2: "px-4 py-2.5 text-sm md:text-base",
  3: "px-5 py-3 text-base md:text-lg",
  4: "px-5 py-3.5 text-lg md:text-xl",
  5: "px-6 py-4 text-xl md:text-2xl",
};

export default function TopicWall() {
  return (
    <section id="topics" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <SectionHeading
            label="Topic Wall"
            title="话题墙：大家正在围观的关键词"
            desc="词越大代表最近讨论越密集，点一下就能顺着话题摸到对应的现场与事件整理。"
          />

          <div className="mt-8 md:mt-10 flex flex-wrap gap-2.5 md:gap-3">
            {topicWall.map((topic) => (
              <a
                key={topic.name}
                href="#covers"
                className={`group inline-flex items-baseline gap-2 rounded-full border border-background-300 bg-background-50 cursor-pointer hover:border-primary-400 hover:bg-primary-50 transition-colors ${sizeMap[topic.size]}`}
              >
                <span className="font-medium text-foreground-900 group-hover:text-primary-700 transition-colors">
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-400 tabular-nums">{topic.count}</span>
              </a>
            ))}
          </div>

          <p className="mt-8 text-sm text-foreground-500">
            话题墙每小时刷新一次，出现频率越高的话题会自然长大。
          </p>
        </div>
      </div>
    </section>
  );
}